import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useSubscription } from "@/hooks/useSubscription";
import { SubscribeGate } from "./SubscribeGate";

export function RequireSubscription({ children }: { children: JSX.Element }) {
  const { user, loading: authLoading } = useAuth();
  const { isSubscribed, loading } = useSubscription();

  if (authLoading || loading) {
    return <div className="p-10 text-muted-foreground">Loading…</div>;
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (!isSubscribed) return <SubscribeGate />;
  return children;
}

export default RequireSubscription;